// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".errorCode[data-v-4ef22dc4]{font-size:5em}.errorDesc[data-v-4ef22dc4]{font-size:1.5em}", ""]);
// Exports
module.exports = exports;
